<template>
  <section class="gurantee-full-wrap new-full-about strong-section p-0">
        <div class="barana-img"><img alt="" class="w-100" src="/assets/images/new_home/product-details-img1.jpg"></div>
        <div class="barana-text">
            <div class="container">
                <div class="row">
                    <div class="col-md-12 ms-md-auto aos-init aos-animate" data-aos="fade-right">
                    <h2>A strong foundation is essential for healthy living</h2>

                    <p>Absolutely! A strong foundation is crucial for maintaining overall health and well-being — and products like the CYM GSH Complex play a key role in supporting that foundation. As shown on the GSH Complex is formulated with Whey Protein Isolate and designed to support your immune system and cellular health, making it a smart addition to a healthy lifestyle.</p>
                        <p>If you're looking for a reliable supplement to build a strong health base, this could be a great option to consider.</p>

                    <h3>Immunity</h3>

                    <p>A strong immune system defends against infections, inflammation, and chronic conditions. CYM GSH Complex offers foundational support, especially important for those facing stress, fatigue, or environmental toxins.</p>
                        <h3>Skin Health</h3>
                        <p>Daily exposure to pollutants, stress, and UV rays accelerates skin aging and dullness. CYM GSH Complex supports skin clarity, tone, and resilience from the inside out — a true beauty-from-within supplement.</p>
                        <h3>Anti-Aging</h3>
                        <p>Aging isn’t just about appearance — it's about staying active, sharp, and strong. This formula gives your body the internal support it needs to age gracefully and stay healthier for longer.</p>
                    </div>
                </div>

            </div>
        </div>
    </section>

     <section class="products-related-gsh complex-sec2">
        <div class="container-fluid">
            <div class="row" data-aos="fade-up">
                <div class="col-md-6 mb-4 mb-md-0"><img src="/assets/images/new_home/GSH-Complex_1.jpg" alt=""></div>
                <div class="col-md-6">
                    <h2>GSH COMPLEX</h2>
                    <h3>A natural dietary supplement supporting your body's antioxidant function</h3>
                    <p>GSH Complex is made from high-quality, minimally processed fresh dairy whey and is formulated to support your body’s natural production of glutathione—often referred to as the “master antioxidant.” Glutathione plays a key role in maintaining overall cellular health and supporting normal immune function.</p>
                </div>
            </div>
        </div>
    </section>

     <section class="gurantee-full-wrap new-full-about new-process-content p-0">
        <div class="barana-img-right"><img alt="" class="w-100" src="/assets/images/new_home/product-details-img2.jpg"></div>
            <div class="barana-text">
                <div class="container">
                    <div class="row">
                        <div class="col-md-6  aos-init aos-animate" data-aos="fade-right">
                            <h2>Groundbreaking Provida CVE Production Process</h2>

                            <p>Backed by more than 30 years of scientific and formulation expertise, our team developed Provida CVE—a unique production process designed to support the body’s natural cellular function. This innovation helps make GSH Complex® a distinctive, well-balanced protein peptide formula that nourishes your cells.</p>
                            <p>GSH Complex® is inspired by decades of scientific studies and ongoing research into the roles of amino acids and antioxidants in human health.<br>
<a href="https://pubmed.ncbi.nlm.nih.gov/" target="_blank">(https://pubmed.ncbi.nlm.nih.gov/)</a></p>
                            <p>https://pubmed.ncbi.nlm.nih.gov/</p>

                            <div class="cve-dls">
                                <h4>Dr. Robert Bender, MD.,FAAFP</h4>
                                <p><strong>INGREDIENTS:</strong> Whey Protein Isolate, Sunflower Lecithin (For solubility only <1%)</p>
                                    <p><strong>FORMAT:</strong> Family Pack (450 g/15.8 oz)</p>
                                <p><strong>SUPPLY:</strong> 45 days</p>
                            </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup>
import { ref, computed, defineProps, onMounted, watch } from "vue";
import { useRoute } from "vue-router";
import axios from "axios";
import { useLoginStore } from "../../stores/login";
import { useCartStore } from "../../stores/cart";
import { userLanguage } from "../../stores/language";
const userLanguages = userLanguage();
const cartData = useCartStore();
const route = useRoute();
let props = defineProps(["translationText"]);
</script>
